import { render, staticRenderFns } from "./poll-mobile-review.vue?vue&type=template&id=3be84114&scoped=true&"
import script from "./poll-mobile-review.vue?vue&type=script&lang=js&"
export * from "./poll-mobile-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be84114",
  null
  
)

export default component.exports